module.exports = __webpack_public_path__ + "img/head2.3c6d6375.png";